<template>
  <div class="container-fluid">
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>Create Issue</h3>
        <hr />
        <el-form
          @submit.native.prevent
          class="form"
          ref="form"
          :model="form"
          label-width="150px"
          label-position="left"
        >
          <el-form-item class="form-item" label="Customer">
            <el-autocomplete
              style="width: 100%"
              id="customer-contact"
              class="inline-input"
              v-model="installationContact"
              :fetch-suggestions="contactSearch"
              placeholder="Search contact"
              prefix-icon="el-icon-search"
              @select="contactSelected"
            ></el-autocomplete>
          </el-form-item>

          <el-form-item class="form-item" label="Assigned To">
            <el-autocomplete
              style="width: 100%"
              id="customer-contact"
              class="inline-input"
              v-model="assignedTo"
              :fetch-suggestions="userSearch"
              placeholder="Search User"
              prefix-icon="el-icon-search"
              @select="userSelected"
            ></el-autocomplete>
          </el-form-item>

          <el-form-item class="form-item" label="Issue Description">
            <el-input type="textarea" :rows="3" id="customer-description" v-model="form.issue"></el-input>
          </el-form-item>

          <el-form-item class="form-item" label="Timeline">
            <el-date-picker
              v-model="form.timeline"
              type="daterange"
              align="right"
              start-placeholder="Start Date"
              end-placeholder="End Date"
              format="yyyy/MM/dd"
              value-format="yyyy-MM-dd"
              v-on:change="value"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="customer-btn" @click="onSubmit()">Create</el-button>
          </el-form-item>
        </el-form>
        <!-- {{systemTypes}} -->
      </div>
    </vk-offcanvas>
    <!-- <div class="page-content__header-description">Device Managements</div> -->
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div class="page-content__header-description" style="display: flex; margin-bottom: 20px;">
        <h2 style="flex: 1;">Maintenance</h2>

        <can I="am" a="manager">
          <span style="display: flex; align-items: center;">
            <button class="btn btn-primary" @click="showOffCanvas = true">New Maintenance</button>
          </span>
        </can>
        <!-- <a class="btn btn-primary" :href="productReg+`${getRegUri(getUserSession.id)}`">
          Create Request &nbsp;
          <span class="fa fa-plus"></span>
        </a>-->
      </div>
      <!-- {{zohoModules}} -->
      <div class="col-xl-12 col-lg-12 col-md-12">
        <div class="container-fluid">
          <Enquiries></Enquiries>
          <!-- <el-tabs v-model="activeTab">
            <can I="create" a="installation">
              <el-tab-pane label="Manage Requests" name="manage_requests">
                <ManageRequests></ManageRequests>
              </el-tab-pane>
            </can>
            <can I="manage" a="mine">
              <el-tab-pane label="Device Request" name="device_request">
                <DeviceRequest></DeviceRequest>
              </el-tab-pane>
            </can>
            <can I="update" a="installation">
              <el-tab-pane label="Approved Installations" name="approved_installations">
                <ApprovedInstallations></ApprovedInstallations>
              </el-tab-pane>
            </can>
            
              <el-tab-pane label="All Devices" name="all_devices">
                <<MyDeviceList></MyDeviceList>
              </el-tab-pane>
           
          </el-tabs>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Enquiries from "../enquiries/index";
import { mapGetters, mapActions } from "vuex";
// import { ZOHOTHTTP } from "../../../store/actions";
import axios from "axios";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
  DatePicker,
  DateRange
  // ...
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { now } from "moment";

var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function(e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = ((n & 3) << 4) | (r >> 4);
      u = ((r & 15) << 2) | (i >> 6);
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t =
        t +
        this._keyStr.charAt(s) +
        this._keyStr.charAt(o) +
        this._keyStr.charAt(u) +
        this._keyStr.charAt(a);
    }
    return t;
  },
  decode: function(e) {
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9+/=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = (s << 2) | (o >> 4);
      r = ((o & 15) << 4) | (u >> 2);
      i = ((u & 3) << 6) | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function(e) {
    e = e.replace(/rn/g, "n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode((r >> 6) | 192);
        t += String.fromCharCode((r & 63) | 128);
      } else {
        t += String.fromCharCode((r >> 12) | 224);
        t += String.fromCharCode(((r >> 6) & 63) | 128);
        t += String.fromCharCode((r & 63) | 128);
      }
    }
    return t;
  },
  _utf8_decode: function(e) {
    var t = "";
    var n = 0;
    var r = (c1 = c2 = 0);
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode(
          ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        n += 3;
      }
    }
    return t;
  }
};

export default {
  name: "",
  data() {
    return {
      assignedTo: null,
      installationContact: null,
      selectedPaymentModel: [],
      packageConfigs: [],
      paymentModel: `OS`,
      orderVat: 5,
      orderDiscount: 0,
      regDataParams: {
        firstName: null,
        roleType: "customer",
        lastName: null,
        dateOfBirth: new Date(),
        gender: 0,
        phoneNumber: null,
        realm: "",
        username: "",
        email: null,
        street_route: null,
        password: "<%DUMMY%>",
        cpassword: "<%DUMMY%>",
        stateId: null,
        countryId: 1,
        lgaId: null,
        deviceRequest: {
          paymentModel: "OS",
          orderVat: 5,
          orderDiscount: 0,
          typeOfBuilding: "Normal",
          roofType: "Aluminium",
          roofCondition: "Very Good",
          roofReadiness: "Very Ready",
          roofAge: 4,
          roofComment: "No comment here	Roof is ready for installation",
          deviceTypeId: null,
          comment: "No comment here	Roof is ready for installation"
        }
      },
      zohoToken: {},
      zohoModules: [],
      systemTypes: [],
      contactList: [],
      assignList: [],
      form: {
        assignedTo: "",
        issue: "",
        start: "",
        end: ""
      },
      productReg: "https://arnergy.surge.sh/products.html?q=",
      activeTab: this.$can("manage", "mine")
        ? "device_request"
        : "manage_requests",
      showOffCanvas: false
    };
  },
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    "el-date-picker": DatePicker,
    // DeviceRequest,
    Enquiries
    // HotelDatePicker
    // ManageRequests,
    // ScheduleInstallation,
    // ApprovedInstallations,
    // MyDeviceList,
    // RightBar
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {
    ...mapGetters(["getUserSession", "getUsers"])
  },

  // watch: {
  //   paymentModel: function(newVal, oldVal) {
  //     this.selectedPaymentModel = this.packageConfigs.find(
  //       x => x.Package == newVal
  //     );
  //     this.regDataParams.deviceRequest.paymentModel = newVal;
  //   }
  // },
  methods: {
    // calcSetup(paymentModel) {
    //   let setupPercent = Number(this.selectedPaymentModel["Setup"]);
    //   // console.log({ setupPercent });
    //   return setupPercent * this.form.price;
    // },
    // calcSub(paymentModel) {
    //   let subscriptionPercent = Number(
    //     this.selectedPaymentModel["Subscription"]
    //   );
    //   // console.log({ subscriptionPercent });
    //   return subscriptionPercent * this.form.price;
    // },
    value() {
      // this.form.timeline =
      this.form.start = this.form.timeline[0];
      this.form.end = this.form.timeline[1];
      delete this.form.timeline;

      // console.log({
      //   form: JSON.stringify(this.form)
      // })
    },
    onSubmit() {
      // console.log(this.form);
      const container = this;
      const HTTP = this.$httpUtils.instance;
      HTTP.post("/maintenance", this.form)
        .then(response => {
          // console.log(response);
          container.showInfoMsg({
            message: "Complaint Added"
          });
          container.showOffCanvas = false;
          window.location.reload();
          //container.init();
        })
        .catch(error => {
          console.log("error", error);
          this.showErrorMsg({
            message: error
          });
        });
    },
    // async onSubmit() {
    //   this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
    //   this.regDataParams.deviceRequest.orderDiscount = this.orderDiscount;
    //   this.regDataParams.deviceRequest.orderVat = this.orderVat;
    //   let regDataParams = this.regDataParams;
    //   // let orderDiscount = this.orderDiscount;
    //   // let orderVat = this.orderVat;
    //   // console.log({ regDataParams });
    //   const HTTP = this.$httpUtils.instance;
    //   try {
    //     let resp = await HTTP.post("/users", regDataParams);
    //   } catch (error) {
    //     if (error.response) {
    //       if (error.response.data) {
    //         // console.log(error.response.data);
    //         let error_incomming = error.response.data.error.details.messages;
    //         // console.log(error_incomming);
    //         let tempMsg = Object.keys(error_incomming).map(
    //           x => `${x}: ${error_incomming[x].join(",")}`
    //         );
    //         this.showErrorMsg({
    //           message: tempMsg.join("<br>")
    //         });
    //       }
    //     }
    //     console.log({
    //       error
    //     });
    //   }
    //   // .then(resp => {
    //   //   console.log(resp);
    //   // })
    //   // .catch(function(error_incomming) {
    //   //   console.log(error_incomming);
    //   // let tempMsg = Object.keys(error_incomming["messages"]).map(
    //   //   x => `${x}: ${error_incomming[x].join(",")}`
    //   // );
    //   // this.showWarnMsg({
    //   //   message: tempMsg.join("<br>")
    //   // });
    //   // });
    // },
    // packageSelected() {
    //   this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
    //   this.form.price = this.systemTypes.find(x => x.id == this.form.package)[
    //     "price"
    //   ];
    //   // console.log({
    //   //   form: this.form
    //   // });
    // },
    contactSelected(contact) {
      this.form = {
        ...this.form,
        installationId: contact["id"]
      };
    },
    userSelected(user) {
      this.form = {
        ...this.form,
        assignedTo: user["id"]
      };
      console.log({
        form: this.form
      });
    },
    getRegUri(data) {
      return Base64.encode(`�6` + data);
    },
    // loadAll() {
    //   console.log("++++++++++++++++++++++++++");
    //   // console.log(this.zohoToken);
    //   const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
    //   let container = this;
    //   ZOHOTHTTP.get(`fetchAll`, {
    //     params: {
    //       collection: "Leads?fields=Email,First_Name,Last_Name,Phone"
    //     }
    //   })
    //     .then(response => response.data["result"]["data"])
    //     .then(tempList => {
    //       // console.log(tempList);

    //       container.contactList = tempList.map(x => ({
    //         ...x,
    //         value: `${x.First_Name} ${x.Last_Name}`
    //       }));
    //     })
    //     .catch(e => {
    //       console.log("========Err=========");
    //       console.log(e);
    //       // this.refreshZohoToken();
    //     });
    // },
    // loadModules() {
    //   console.log("++++++++++++++++++++++++++");
    //   // console.log(this.zohoToken);
    //   const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
    //   let container = this;
    //   ZOHOTHTTP.get(`/settings/all`, {
    //     headers: {
    //       Authorization: `Zoho-oauthtoken ${this.zohoToken["accessToken"]}`,
    //       "Content-Type": " application/json;charset=UTF-8"
    //     }
    //   })
    //     .then(response => {
    //       container.zohoModules = response.data["data"];
    //     })
    //     .catch(e => {
    //       console.log("========Err=========");
    //       console.log(e);
    //       // this.refreshZohoToken();
    //     });
    // },
    // createFilter(queryString, contact) {
    //   return (
    //     `${contact.First_Name} ${contact.Last_Name}`
    //       .toLowerCase()
    //       .indexOf(queryString.toLowerCase()) > -1
    //   );
    // },
    createContactFilter(queryString, user) {
      //   console.log(user.name)
      return (
        `${user.name}`.toLowerCase().indexOf(queryString.toLowerCase()) > -1
      );
    },
    createUserFilter(queryString, user) {
      return (
        `${user.firstName} ${user.lastName}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    contactSearch(queryString, cb) {
      let contacts = this.contactList;
      var results = queryString
        ? contacts.filter(contact =>
            this.createContactFilter(queryString, contact)
          )
        : contacts;
      cb(results);
    },
    userSearch(queryString, cb) {
      let users = this.assignList;
      var results = queryString
        ? users.filter(user => this.createUserFilter(queryString, user))
        : users;
      cb(results);
    },
    // async fetchZohoToken() {
    //   const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
    //   return await ZOHOTHTTP.get("get-zoho-token");
    // },
    async fetchPackageConfig() {
      const HTTP = this.$httpUtils.instance;
      return await HTTP.get("/package-configs");
    },
    // async refreshZohoToken() {
    //   const HTTP = this.$httpUtils.instance;
    //   let newToken = await HTTP.post("/zohos/refresh-zoho-token");
    //   this.zohoToken = newToken.data.token;
    //   this.loadAll();e
    // },
    fetchSysTypes() {
      const HTTP = this.$httpUtils.instance;
      const url =
        "/device_types?filter[include][packageComponents]=componentType";
      return HTTP.get(url)
        .then(response => {
          this.systemTypes = response.data;
          // console.log({ systemTypes });
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    fetchAssignList() {
      const HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      const url = `/users?filter[include][installations]=deviceType&filter[where][roleType]=customer operations engineer`+`&filter[order]=id DESC`;
      HTTP.get(url)
        // .then(response => {
        //   const usersList = response.data;
        //   console.log(usersList)
        //   this.$store.commit("saveUsers", usersList);
        //   // console.log(this.getUserById(1))
        // })
        .then(response => response.data)
        .then(tempList => {
          // console.log(tempList);

          this.assignList = tempList.map(x => ({
            ...x,
            value: `${x.firstName} ${x.lastName}`
          }));
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    fetchContactList() {
      const HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      const url = `/installations?filter={"include":["deviceType","user"]}`;
      //  url = `/users?filter[include][installations]=deviceType&filter[where][roleType]=customer`;
      HTTP.get(url)
        // .then(response => {
        //   const usersList = response.data;
        //   console.log(usersList)
        //   this.$store.commit("saveUsers", usersList);
        //   // console.log(this.getUserById(1))
        // })
        .then(response => response.data)
        .then(tempList => {
          // console.log(tempList);
          //  this.contactList = tempList.filter(x =>  {
          //             if(x.name.trim() !== '- -'){
          //                console.log(x.name);
          //             }
          //           });
          this.contactList = tempList
            .filter(x => x.name.trim() !== "- -")
            .map(x => ({
              ...x,
              value:
                `${x.name} ` + ` ${x.deviceType.name},  ` + ` ${x.solarKitIds}`
            }));

          // x.name.trim() !== '- -' ? ({
          //   ...x,
          //   value: `${x.name} ` + ` ${x.deviceType.name},  `     + ` ${x.solarKitIds}`
          // }): false);
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  async mounted() {
    // let _tmpdata = await this.fetchZohoToken();
    let tmpPackageConfig = await this.fetchPackageConfig();
    this.packageConfigs = tmpPackageConfig["data"];
    // console.log(this.zohoToken.data.token);
    // this.zohoToken = _tmpdata.data.token;
    // this.loadAll();
    this.fetchSysTypes();
    this.assignList = this.fetchAssignList();
    this.contactList = this.fetchContactList();

    // axios.interceptors.response.use(
    //   function(response) {
    //     return response;
    //   },
    //   function(error) {
    //     console.log(error);
    //     // handle error
    //     if (error.response) {
    //       alert(error.response.data.message);
    //     }
    //   }
    // );
    // const HTTP = this.$httpUtils.instance;

    // this.loadModules();
  }
};
</script>

<style lang="scss" scoped>
.container-fluid .page-content {
  padding: 0px !important;
}

.container-fluid .container-fluid {
  padding: 0px !important;
}
.el-form-item__label {
  text-align: left !important;
}
.el-select-dropdown__item {
  line-height: 20px;
  display: flex;
  flex-flow: column;

  span {
    line-height: 20px !important;
  }
}
.price-display {
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/submodules/support.vue